import { render, staticRenderFns } from "./searchIntro.vue?vue&type=template&id=42883682&scoped=true&"
import script from "./searchIntro.vue?vue&type=script&setup=true&lang=js&"
export * from "./searchIntro.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./searchIntro.vue?vue&type=style&index=0&id=42883682&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42883682",
  null
  
)

export default component.exports